import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { TopicThread } from 'models/topicThread';
import { ServicesContext } from 'services/context';
import './abuseCover.html';

export interface CommentAbuseCoverVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentAbuseCoverVM {
    private comment: Subscribable<TopicThread | undefined>

    labels = labels

    title: Subscribable<string>
    isBusy = ko.observable(false);

    constructor(
        @inject(wccModules.componentConfig) config: CommentAbuseCoverVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.servicesContext) private ctx: ServicesContext
    ) {
        this.comment = ko.flattenComputed(config.comment);
        const isDeleted = this.comment.pluck('isDeleted', false);
        const isReportedAsAbuse = this.comment.pluck('isReportedAsAbuse', false);

        this.title = this.comment.mapNotNull(c => (c.parentId() ?? '').length > 0 ? labels.YouHaveReportedThisReplyAsAbusive : labels.YouHaveReportedThisCommentAsAbusive).default('');

        const isVisible = ko.pureComputed(() => !isDeleted() && isReportedAsAbuse());

        ko.applyBindingsToNode(info.element, {
            'visible': isVisible,

            'css': {
                'wcc-dark-cover': true
            }
        }, this);
    }

    undo = async () => {
        const commentId = this.comment()?.id();

        try {
            if (commentId == undefined)
                throw new Error(messages.InvalidRequest);

            this.isBusy(true);

            await this.ctx.commentsService.toggleAbuseReport(commentId);
        } finally {
            this.isBusy(false);
        }
    }
}